/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { LoginChangePasswordForm } from '@/components/content/Login/parts/LoginChangePasswordForm';
import { LoginForm } from '@/components/content/Login/parts/LoginForm';
import { loginContainerSX } from '@/components/content/Login/styles/container';
import { UserLogon, personMutatorKeyMatcher, useLogin } from '@/data/Content/Login';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useLocalization } from '@/data/Localization';
import { ID } from '@/data/types/Basic';
import { Box, Paper, Stack } from '@mui/material';
import { FC } from 'react';
import { useSWRConfig } from 'swr';

export const Login: FC<{ id: ID }> = () => {
	const router = useNextRouter();
	const RouteLocal = useLocalization('Routes');
	const { mutate } = useSWRConfig();

	const { loginSubmit, setPasswordExpired, passwordExpired } = useLogin();

	const handleLogin = async (props: UserLogon) => {
		const resp = await loginSubmit(props);
		if ('userId' in resp ?? {}) {
			if (router.query.flow === 'checkout') {
				await router.push(RouteLocal.CheckOut.route.t());
			} else {
				await router.push('/');
			}
			await mutate(personMutatorKeyMatcher(''), undefined);
		}
	};

	const onCancel = () => {
		setPasswordExpired(null);
	};

	return (
		<Stack direction={'row'} justifyContent={'flex-end'}>
			<Box sx={{ flex: { xs: '1 0 auto', sm: '0 1 25rem' } }}>
				<Paper sx={loginContainerSX} elevation={0}>
					{passwordExpired !== null ? (
						<LoginChangePasswordForm
							onSubmit={handleLogin}
							onCancel={onCancel}
							passwordExpired={passwordExpired}
						/>
					) : (
						<LoginForm onSubmit={handleLogin} />
					)}
				</Paper>
			</Box>
		</Stack>
	);
};
